export const studio = {
  name: "Viis Labs",
  mark: "/assets/viis-labs-mark.svg",
  tagline: "Independent apps, crafted with care.",
  description:
    "We design focused iPhone experiences that solve one real problem beautifully — with calm interfaces, thoughtful motion, and privacy built in.",
  turnstileSiteKey: "0x4AAAAAAD0-x7T5o2gxIjPL",
};

export const apps = [
  {
    name: "MoCue",
    slug: "mocue",
    bundleId: "viis.fast.mocue",
    eyebrow: "Passenger comfort in motion",
    status: "Preparing for launch",
    category: "Travel · Comfort · iPhone",
    description:
      "A motion-aware visual companion for passengers. It turns live device motion into calm visual cues and can remain visible in Picture in Picture while you use other apps.",
    highlights: [
      "Three finely tuned visual cue styles",
      "Picture in Picture floating cue",
      "On-device motion processing",
      "Shortcuts and multilingual support",
    ],
    accent: "#75D5C7",
    icon: "/assets/mocue-icon.png",
    appStoreUrl: null,
    appStoreStatus: "Coming soon to the App Store",
    routes: {
      details: "/apps/mocue/",
      privacy: "/apps/mocue/privacy/",
      terms: "/apps/mocue/terms/",
      support: "/apps/mocue/contact/",
    },
    legal: {
      updated: "July 13, 2026",
      contactEmail: null,
    },
  },
];
